import React from 'react'
import './Snacks.css'
import snacksLogo from '../images/my-res-snacks.jpg'
import { useSelector, useDispatch } from 'react-redux'
import { burgerTypeDecrease, burgerTypeIncrease, friesTypeDecrease, friesTypeIncrease, pizzaTypeDecrease, pizzaTypeIncrease, wrapTypeDecrease, wrapTypeIncrease } from '../redux/snacks/snacksActions'
import { Link } from 'react-router-dom'
import Order from './Order'

const Snacks = () => {
    const burgers = useSelector(state => state.snacks.burgers)
    const burgerPrice = useSelector(state => state.snacks.burgerPrice)
    const fries = useSelector(state => state.snacks.fries)
    const friesPrice = useSelector(state => state.snacks.friesPrice)
    const wraps = useSelector(state => state.snacks.wraps)
    const wrapsPrice = useSelector(state => state.snacks.wrapsPrice)
    const pizzas = useSelector(state => state.snacks.pizzas)
    const pizzasPrice = useSelector(state => state.snacks.pizzasPrice)
    const dispatch = useDispatch()
    const snacks = {
        'Burger' : 150,
        'French Fries' : 75,
        'Wrap' : 100,
        'Pizza' : 180
    }
  return (
    <div className='snacks'>
        <ul className='snacks__list'>
            <li className="snacks__item">
                    <button className='snacks__btn' onClick={() => dispatch(burgerTypeIncrease())}> + </button>
                    <p className='snackItemName'>Burger - &#8377;150</p>
                    <button className='snacks__btn' onClick={() => {if(burgers > 0) dispatch(burgerTypeDecrease())}}> - </button>
                    <p className='snackItemPrice'><span>{burgers}</span> <span>&#8377;{burgerPrice}</span></p>
            </li>
            <li className="snacks__item">
                    <button onClick={() => dispatch(friesTypeIncrease())}> + </button>
                    <p className='snackItemName'>French Fries - &#8377;75</p>
                    <button onClick={() => {if(fries > 0) dispatch(friesTypeDecrease())}}> - </button>
                    <p className='snackItemPrice'><span>{fries}</span> <span>&#8377;{friesPrice}</span></p> 
            </li>
            <li className="snacks__item">
                    <button  onClick={() => dispatch(wrapTypeIncrease())}> + </button>
                    <p className='snackItemName'>Wrap - &#8377;125</p>
                    <button onClick={() => {if(wraps > 0) dispatch(wrapTypeDecrease())}}> - </button>
                    <p className='snackItemPrice'><span>{wraps}</span> <span>&#8377;{wrapsPrice}</span></p>
            </li>
            <li className="snacks__item">
                    <button  onClick={() => dispatch(pizzaTypeIncrease())}> + </button>
                    <p className='snackItemName'>Pizza - &#8377;180</p>
                    <button onClick={() => {if(pizzas > 0) dispatch(pizzaTypeDecrease())}}> - </button>
                    <p className='snackItemPrice'><span>{pizzas}</span> <span>&#8377;{pizzasPrice}</span></p>
            </li>
        </ul>
        <div className="snacks__buttons">
            <Link to='/food'><button  className='btn_text btn1'>Food</button></Link>
            <img src={snacksLogo} alt="" className='snacks__img'/>
            <Link to='/drinks'><button className='btn_text btn2'>Beverages</button></Link>
        </div>
        <Order />
    </div>
  )
}

export default Snacks